import { getPlacementLabel } from "./themeEditorLinks";

export const TEMPLATE_FILTER_OPTIONS = [
  { label: "Show all templates", value: "all" },
  { label: "Only published", value: "published" },
  { label: "Only draft", value: "draft" },
  { label: "Only primary", value: "primary" },
  { label: "Product page", value: "placement:product_page" },
  { label: "Cart page", value: "placement:cart_page" },
  { label: "Store-wide bar", value: "placement:announcement_bar" },
  { label: "Home page", value: "placement:home_page" },
];

export function filterTemplateRows(rows, filterKey) {
  const key = filterKey || "all";
  if (key === "all") return rows;

  return rows.filter((row) => {
    switch (key) {
      case "published":
        return !!row.is_published;
      case "draft":
        return !row.is_published;
      case "primary":
        return !!row.is_primary;
      default:
        if (key.startsWith("placement:")) {
          return row.placement_type === key.slice("placement:".length);
        }
        return true;
    }
  });
}

export function searchTemplateRows(rows, query) {
  const q = String(query || "").trim().toLowerCase();
  if (!q) return rows;

  return rows.filter((row) => {
    const placement = getPlacementLabel(row.placement_type);
    const status = row.is_published ? "published" : "draft";
    const goal = `$${row.goal_amount ?? ""} ${row.currency_code || ""}`.trim();
    const hay = [
      row.name,
      placement,
      row.placement_type,
      goal,
      status,
      row.is_primary ? "primary" : "",
    ]
      .join(" ")
      .toLowerCase();
    return hay.includes(q);
  });
}

export function filterLabel(value) {
  return TEMPLATE_FILTER_OPTIONS.find((o) => o.value === value)?.label || "Show all templates";
}
